var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15, _g16;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgQuote = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    x: "0px",
    y: "0px",
    width: "50px",
    height: "50px",
    viewBox: "0 0 516.375 516.375",
    style: {
      enableBackground: "new 0 0 516.375 516.375"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 133.875,
    y: 420.75,
    width: 248.625,
    height: 19.125
  }), /*#__PURE__*/React.createElement("rect", {
    x: 133.875,
    y: 133.875,
    width: 133.875,
    height: 19.125
  }), /*#__PURE__*/React.createElement("rect", {
    x: 133.875,
    y: 363.375,
    width: 248.625,
    height: 19.125
  }), /*#__PURE__*/React.createElement("rect", {
    x: 133.875,
    y: 76.5,
    width: 133.875,
    height: 19.125
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.125,0h-9.562H114.75C93.712,0,76.5,17.212,76.5,38.25v439.875c0,21.037,17.212,38.25,38.25,38.25h286.875 c21.037,0,38.25-17.213,38.25-38.25V143.438v-9.562L325.125,0z M325.125,28.688l89.888,105.188H344.25 c-9.562,0-19.125-9.562-19.125-19.125V28.688z M420.75,478.125c0,9.562-7.65,19.125-19.125,19.125H114.75 c-9.562,0-19.125-7.65-19.125-19.125V38.25c0-9.562,7.65-19.125,19.125-19.125H306v95.625c0,21.038,17.213,38.25,38.25,38.25h76.5 V478.125z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 133.875,
    y: 306,
    width: 248.625,
    height: 19.125
  }), /*#__PURE__*/React.createElement("rect", {
    x: 133.875,
    y: 191.25,
    width: 248.625,
    height: 19.125
  }), /*#__PURE__*/React.createElement("rect", {
    x: 133.875,
    y: 248.625,
    width: 248.625,
    height: 19.125
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", null)));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgQuote, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/Quote.f84a6bfe.svg";
export { ForwardRef as ReactComponent };